module.exports = __webpack_public_path__ + "./img/mini-arrow-right.svg";